module.exports = __webpack_public_path__ + "static/media/xanh-sm-logo.453aacd3.jpg";